import React, { useState, useEffect } from "react";
import { FaBan, FaBuilding } from "react-icons/fa";
import ArenaProfile from "./arenaProfile";
import StarRating from "./components/StarRating";
import axios from "axios";

const RegisteredArenas = ({ onDisableArena }) => {
  const [arenas, setArenas] = useState([]);
  const [selectedArena, setSelectedArena] = useState(null);

  const fetchArenas = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/registered-arenas`,
        { withCredentials: true }
      );

      setArenas(response.data);
    } catch (error) {
      console.error("Error fetching arenas:", error);
    }
  };

  useEffect(() => {
    fetchArenas();
  }, []);

  const handleArenaClick = (arena) => {
    setSelectedArena(arena);
  };

  const handleCloseProfile = () => {
    setSelectedArena(null);
  };

  const handleDisable = async (id) => {
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_BASE_URL}/api/admin-dashboard/disable-arena?arenaId=${id}`,
        id,
        { withCredentials: true }
      );
      if (response.status === 200) {
        fetchArenas();
        alert(response.data.message);
      } else {
        alert(response.status + " - " + response.data.message);
      }
    } catch (error) {
      console.error("Error fetching arenas:", error);
    }
  };

  return (
    <div className="p-4 max-w-[1200px] mx-auto">
      <h2 className="text-[1.5rem] mb-4">Registered - Enabled Arenas</h2>
      {arenas.map((arena) => (
        <div
          key={arena.id}
          className="bg-[#f9f9f9] rounded-[8px] p-4 mb-4 flex flex-col md:flex-row justify-between md:items-center transition-colors duration-300 hover:bg-[#f0f0f0] cursor-pointer"
          onClick={() => handleArenaClick(arena)}
        >
          <div className="flex-1">
            <div className="flex items-center gap-2">
              <h3 className="m-0 text-[1.2rem]">{arena.name}</h3>
              {arena.institute && (
                <FaBuilding
                  className="text-[#3498db]"
                  title={`Associated with Institute: ${arena.institute.name}`}
                />
              )}
            </div>
            <p className="my-2 text-[0.9rem]">{arena.location}</p>
            {arena.institute && (
              <p className="m-0 text-[0.8rem] text-[#6c757d]">
                Institute: {arena.institute.name} ({arena.institute.institute_type_name})
              </p>
            )}
            <div className="flex items-center gap-2 mt-2">
              <StarRating rating={arena.overall_rating?.avg_rating || 0} showNumber={true} />
              <span className="text-[#6c757d] text-[0.8rem]">
                ({arena.overall_rating?.total_ratings || 0} reviews)
              </span>
            </div>
          </div>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDisable(arena.id);
            }}
            className="px-4 py-2 border-0 rounded text-white flex items-center text-[0.9rem] bg-[#e74c3c] hover:bg-[#c0392b] transition-colors duration-300 md:flex-none md:justify-start w-full md:w-auto justify-center"
          >
            <FaBan className="mr-2" /> Disable
          </button>
        </div>
      ))}
      {selectedArena && (
        <ArenaProfile arena={selectedArena} onClose={handleCloseProfile} />
      )}
    </div>
  );
};

export default RegisteredArenas;
